import * as React from 'react';
import { styled } from '@linaria/react';

import Demo from '@/components/Demo';
import ArrowShowingDistance from '@/components/ArrowShowingDistance';
import Paper from '@/components/Paper';
import SliderControl from '@/components/Controls/SliderControl';

function BigHelloWorld() {
  const ref = React.useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = React.useState(1);
  const [arrowWidth, setArrowWidth] = React.useState<number | null>(
    null
  );

  React.useEffect(() => {
    if (!ref.current) {
      return;
    }

    const boundingBox = ref.current.getBoundingClientRect();

    setArrowWidth(boundingBox.width);
  }, [fontSize]);

  return (
    <Demo
      initialValues={{}}
      controlPosition="top"
      customGrid={{
        gridTemplateColumns: `min(500px, 100%) !important`,
        justifyContent: 'center',
      }}
      outputWrapper={null}
      renderAltControls={() => (
        <SliderWrapper>
          <SliderControl
            id="fontSize"
            key="fontSize"
            name="fontSize"
            label="font-size"
            value={fontSize}
            setValue={setFontSize}
            min={0.8}
            max={3}
            step={0.1}
            previewRenderer={(val) => `${val}rem`}
          />
        </SliderWrapper>
      )}
    >
      {() => {
        return (
          <Wrapper>
            <Group>
              {typeof arrowWidth === 'number' && arrowWidth > 5 && (
                <ArrowWrapper>
                  <ArrowShowingDistance
                    animateTransitions="label-only"
                    axis="horizontal"
                    unit="rem"
                    distance={arrowWidth + 4}
                    flipTextSide
                  />
                </ArrowWrapper>
              )}
              <Sentence
                ref={ref}
                style={{ fontSize: `${fontSize}rem` }}
              >
                <strong>Hello World!</strong>
              </Sentence>
            </Group>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const SliderWrapper = styled.div`
  width: 360px;
  max-width: 100%;
  margin-inline: auto;
`;

const Wrapper = styled(Paper)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 14rem;
`;

const Group = styled.div`
  position: relative;
`;

const Sentence = styled.div`
  display: block;
  width: fit-content;
  outline: solid var(--color-secondary);
  font-size: 3rem;
  border-radius: 2px;
`;

const ArrowWrapper = styled.div`
  position: absolute;
  transform: translate(-2px, -100%);
  top: -8px;
`;

export default BigHelloWorld;
